<template>
  <li
    class="[&:not(:last-child)]:before:border-l-gray-30 relative flex gap-x-3 [&:not(:last-child)]:before:absolute [&:not(:last-child)]:before:bottom-0 [&:not(:last-child)]:before:left-3 [&:not(:last-child)]:before:top-8 [&:not(:last-child)]:before:border-l"
  >
    <div
      class="bg-gray-20 text-gray-70 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-semibold"
      :class="$style.stepIndicator"
    ></div>
    <div class="flex flex-col gap-y-2 pb-4">
      <h3 class="text-gray-90 flex min-h-6 items-center text-sm font-semibold">{{ title }}</h3>
      <div class="text-gray-70 text-sm empty:hidden">
        <slot />
      </div>
    </div>
  </li>
</template>

<script setup lang="ts">
defineProps<{
  title: string
}>()
</script>

<style lang="scss" module>
.stepIndicator {
  &::before {
    content: counter(stepper);
    counter-increment: stepper;
  }
}
</style>
